/**
 * 동의어 토큰 입력 ↔ 목록 (AMZUWEB-694).
 *
 * 운영자는 한 칸에 「팬던트, 펜던트, pendant」 처럼 쉼표로 적는다. 줄바꿈도 같은 구분으로 받는다 —
 * 엑셀에서 세로로 복사해 붙여 넣는 경우가 많다. 서버도 같은 규칙으로 다시 정리하지만(공백·중복),
 * 화면이 먼저 정리해 두어야 칩 · 미리보기 · 저장 버튼이 서버와 같은 목록을 본다.
 */
export const parseTerms = (text: string): string[] => {
  const seen = new Set<string>();
  const terms: string[] = [];
  for (const raw of text.split(/[,\n]/)) {
    const term = raw.trim().replace(/\s+/g, ' ');
    const key = term.toLowerCase();
    if (!term || seen.has(key)) continue;
    seen.add(key);
    terms.push(term);
  }
  return terms;
};

export const formatTerms = (terms: string[]): string => terms.join(', ');

/** 같은 줄인지 — 동의어 줄에서 순서·대소문자는 뜻이 없다(서버의 sameTerms 와 같은 기준) */
export const sameTerms = (a: string[], b: string[]): boolean => {
  const normalize = (list: string[]): string[] =>
    [...new Set(list.map((term) => term.trim().replace(/\s+/g, ' ').toLowerCase()))].sort();
  const left = normalize(a);
  const right = normalize(b);
  return left.length === right.length && left.every((term, index) => term === right[index]);
};
